import { useNavigate } from "react-router-dom";
import { ArrowLeft, House } from "@phosphor-icons/react";
import { Button } from "@opero/ui";

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="relative flex min-h-[calc(100dvh-5rem)] flex-col items-center justify-center px-6 py-12 text-center">
      <div
        aria-hidden
        className="pointer-events-none absolute left-1/2 top-1/2 -z-10 h-112 w-112 -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary-500/15 blur-[120px] dark:bg-primary-400/10"
      />

      <div className="select-none bg-gradient-to-br from-primary-400 via-primary-600 to-primary-800 bg-clip-text text-[clamp(7rem,18vw,14rem)] font-bold leading-none tracking-tighter text-transparent dark:from-primary-300 dark:via-primary-400 dark:to-primary-600">
        404
      </div>

      <h1 className="mt-2 text-2xl font-semibold text-slate-900 dark:text-slate-100 sm:text-3xl">
        We can't find that page
      </h1>

      <p className="mt-3 max-w-md text-base text-slate-500 dark:text-slate-400">
        The link may be broken or the page may have moved. Try the homepage or get in touch if you need help.
      </p>

      <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
        <Button variant="outline" onClick={() => navigate("/contact")}>
          <ArrowLeft />
          Contact us
        </Button>
        <Button onClick={() => navigate("/")}>
          <House />
          Back to home
        </Button>
      </div>
    </div>
  );
}

export default NotFoundPage;
